/**
 * Formatação de números, moeda e datas.
 *
 * Antes cada página redefinia `fmt`, `fmtBRL` e `hoje` com pequenas variações
 * (umas devolviam '—' para nulo, outras '-'; `hoje` tinha duas implementações).
 * Este arquivo é a fonte única.
 */

const VAZIO = '—';

/** Número com 2 casas: 1234.5 → "1.234,50". */
export const fmt = (v, casas = 2) =>
  v != null && !isNaN(v)
    ? v.toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas })
    : VAZIO;

/** Número sem casas decimais: 1234 → "1.234". */
export const fmtInt = (v) =>
  v != null && !isNaN(v) ? v.toLocaleString('pt-BR', { maximumFractionDigits: 0 }) : VAZIO;

/** Moeda: 1234.5 → "R$ 1.234,50". */
export const fmtBRL = (v) =>
  v != null && !isNaN(v)
    ? v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    : VAZIO;

/** Percentual: 66.666 → "66,67%". */
export const fmtPct = (v, casas = 2) => (v != null && !isNaN(v) ? `${fmt(v, casas)}%` : VAZIO);

/** Data ISO (yyyy-MM-dd) → "dd/MM/yyyy", sem deslocamento de fuso. */
export const fmtData = (iso) => {
  if (!iso) return VAZIO;
  const soData = String(iso).slice(0, 10);
  const [a, m, d] = soData.split('-');
  return a && m && d ? `${d}/${m}/${a}` : VAZIO;
};

/** Data e hora ISO → "dd/MM/yyyy HH:mm". */
export const fmtDataHora = (iso) => {
  if (!iso) return VAZIO;
  const s = String(iso);
  const data = fmtData(s);
  const hora = s.slice(11, 16);
  return hora ? `${data} ${hora}` : data;
};

/** Hoje em yyyy-MM-dd, para value de input[type=date]. */
export const hoje = () => {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
};

/** Agora em yyyy-MM-ddTHH:mm, para value de input[type=datetime-local]. */
export const agora = () => {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
};

/** Corta um ISO para o formato aceito por input[type=datetime-local]. */
export const paraDateTimeLocal = (iso) => (iso ? String(iso).slice(0, 16) : '');
